import React from 'react';
import {useTranslation} from "react-i18next";

interface SuccessAlertProps {
  message: string;
  onClose: () => void;
  redirectDestination: string;
  onRedirect: (destination: string) => void;
  success?: boolean;
}

export const SuccessAlert: React.FC<SuccessAlertProps> = ({
                                                            message,
                                                            onClose,
                                                            redirectDestination,
                                                            onRedirect,
                                                            success = true
                                                          }) => {
  const { t } = useTranslation();
  const [title, ...bodyParts] = message.split('\n');
  const body = bodyParts.join('\n');

  const handleClose = () => {
    onClose(); // Close the alert
    onRedirect(redirectDestination); // Redirect to the passed destination
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 animate-in fade-in zoom-in-75 duration-300">
      <div
        className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm"
        onClick={handleClose}
      />
      <div
        className="relative bg-white rounded-lg shadow-2xl p-4 sm:p-6 max-w-xs sm:max-w-sm md:max-w-md w-[90%] sm:w-full mx-auto border border-gray-200"
      >
        <div className="text-center">
          {success ? (
            <svg
              className="mx-auto h-10 w-10 sm:h-12 sm:w-12 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          ) : (
            <svg
              className="mx-auto h-10 w-10 sm:h-12 sm:w-12 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}
          <p
            className="mt-3 sm:mt-4 text-gray-700 text-base sm:text-lg font-bold leading-6"
          >
            {title}
          </p>
          <p
            className="mt-1.5 sm:mt-2 text-gray-700 text-sm sm:text-base leading-5 sm:leading-6 whitespace-pre-line font-medium"
          >
            {body}
          </p>
        </div>
        <button
          onClick={handleClose}
          style={{ backgroundColor: '#ED6908' }}
          className="mt-4 sm:mt-6 w-full text-white py-2 sm:py-2.5 px-4 rounded-lg hover:bg-opacity-90 transition-colors duration-200 font-semibold text-sm sm:text-base"
        >
          {t('Close')}
        </button>
      </div>
    </div>
  );
};